// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wmde-markdown {
  font-size: 16px;
  line-height: 1.5;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;
}
.wmde-markdown > :first-child {
  margin-top: 0 !important;
}
.wmde-markdown > :last-child {
  margin-bottom: 0 !important;
}
.wmde-markdown code[class*="language-"],
.wmde-markdown pre[class*="language-"] {
  color: black;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  -webkit-hyphens: none;
          hyphens: none;
}
.wmde-markdown pre code {
  background: none;
  overflow-wrap: normal;
  white-space: inherit;
  -moz-tab-size: 2;
       tab-size: 2;
  padding: 16px;
  font-size: 95%;
  line-height: 1.5;
  display: block;
  text-shadow: 0 1px #fff;
}
.wmde-markdown pre {
  margin-bottom: 18px;
  font-size: 85%;
  line-height: 1.45;
  position: relative;
  overflow-x: auto;
  background-color: #f6f8fa;
  border-radius: 3px;
}
.wmde-markdown code,
.wmde-markdown tt {
  background-color: rgba(27, 31, 35, 0.05);
  border-radius: 3px;
  font-size: 85%;
  margin: 0;
  padding: 0.2em 0.4em;
}
.wmde-markdown pre,
.wmde-markdown code,
.wmde-markdown tt {
  font-family: SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
}
.wmde-markdown img {
  max-width: 100%;
}
.wmde-markdown input {
  vertical-align: middle;
  margin: 0 0.2em 0.25em -1.6em;
}
.wmde-markdown input + p {
  display: inline;
}
.wmde-markdown h1,
.wmde-markdown h2 {
  border-bottom: 1px solid #eaecef;
  padding-bottom: 0.3em;
}
.wmde-markdown h1,
.wmde-markdown h2,
.wmde-markdown h3,
.wmde-markdown h4,
.wmde-markdown h5,
.wmde-markdown h6 {
  font-weight: 600;
  line-height: 1.25;
  margin-bottom: 16px;
  margin-top: 24px;
}
.wmde-markdown h1 {
  font-size: 2em;
}
.wmde-markdown h2 {
  font-size: 1.5em;
}
.wmde-markdown h3 {
  font-size: 1.25em;
}
.wmde-markdown h4 {
  font-size: 1em;
}
.wmde-markdown h5 {
  font-size: 0.875em;
}
.wmde-markdown h6 {
  font-size: 0.85em;
}
.wmde-markdown ol,
.wmde-markdown ul {
  padding-left: 2em;
}
.wmde-markdown ol > p,
.wmde-markdown ul > p {
  margin-bottom: 0;
}
.wmde-markdown ul {
  margin-bottom: 16px;
  margin-top: 0;
  list-style: initial;
}
.wmde-markdown > blockquote,
.wmde-markdown > blockquote blockquote {
  margin: 0;
  border-left: 0.25em solid #dfe2e5;
  color: #6a737d;
  padding: 0 1em;
}
.wmde-markdown > blockquote > :last-child,
.wmde-markdown > blockquote blockquote > :last-child {
  margin-bottom: 0;
}
.wmde-markdown > blockquote > :first-child,
.wmde-markdown > blockquote blockquote > :first-child {
  margin-top: 0;
}
.wmde-markdown hr {
  margin: 1.5em auto;
  border: 0;
  border-top: 2px dotted #eee;
  height: 1px;
}
.wmde-markdown > table,
.wmde-markdown > blockquote table {
  display: block;
  overflow: auto;
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 14px;
}
.wmde-markdown > table tr,
.wmde-markdown > blockquote table tr {
  background-color: #fff;
  border-top: 1px solid #c6cbd1;
}
.wmde-markdown > table td,
.wmde-markdown > blockquote table td,
.wmde-markdown > table th,
.wmde-markdown > blockquote table th {
  border: 1px solid #dfe2e5;
  padding: 6px 13px;
}
.wmde-markdown blockquote,
.wmde-markdown details,
.wmde-markdown dl,
.wmde-markdown ol,
.wmde-markdown p,
.wmde-markdown pre,
.wmde-markdown table,
.wmde-markdown ul {
  margin-bottom: 16px;
  margin-top: 0;
}
.wmde-markdown a {
  color: #0366d6;
  text-decoration: none;
}
.wmde-markdown a:hover {
  text-decoration: underline;
}
.wmde-markdown .namespace {
  opacity: 0.7;
}
.wmde-markdown .token.important {
  font-weight: normal;
}
.wmde-markdown .token.bold {
  font-weight: bold;
}
.wmde-markdown .token.italic {
  font-style: italic;
}
.wmde-markdown .token.entity {
  cursor: help;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@uiw/react-markdown-preview/lib/esm/styles/markdown.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,yHAAyH;AAC3H;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;UACb,aAAa;AACvB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;OACX,WAAW;EAChB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;EAEE,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,oBAAoB;AACtB;AACA;;;EAGE,wEAAwE;AAC1E;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;;EAEE,gCAAgC;EAChC,qBAAqB;AACvB;AACA;;;;;;EAME,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,iCAAiC;EACjC,cAAc;EACd,cAAc;AAChB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,WAAW;AACb;AACA;;EAEE,cAAc;EACd,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;AACA;;EAEE,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;;;;EAIE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;;;;;;;;EAQE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd","sourcesContent":[".wmde-markdown {\n  font-size: 16px;\n  line-height: 1.5;\n  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;\n}\n.wmde-markdown > :first-child {\n  margin-top: 0 !important;\n}\n.wmde-markdown > :last-child {\n  margin-bottom: 0 !important;\n}\n.wmde-markdown code[class*=\"language-\"],\n.wmde-markdown pre[class*=\"language-\"] {\n  color: black;\n  text-align: left;\n  white-space: pre;\n  word-spacing: normal;\n  word-break: normal;\n  word-wrap: normal;\n  -webkit-hyphens: none;\n          hyphens: none;\n}\n.wmde-markdown pre code {\n  background: none;\n  overflow-wrap: normal;\n  white-space: inherit;\n  -moz-tab-size: 2;\n       tab-size: 2;\n  padding: 16px;\n  font-size: 95%;\n  line-height: 1.5;\n  display: block;\n  text-shadow: 0 1px #fff;\n}\n.wmde-markdown pre {\n  margin-bottom: 18px;\n  font-size: 85%;\n  line-height: 1.45;\n  position: relative;\n  overflow-x: auto;\n  background-color: #f6f8fa;\n  border-radius: 3px;\n}\n.wmde-markdown code,\n.wmde-markdown tt {\n  background-color: rgba(27, 31, 35, 0.05);\n  border-radius: 3px;\n  font-size: 85%;\n  margin: 0;\n  padding: 0.2em 0.4em;\n}\n.wmde-markdown pre,\n.wmde-markdown code,\n.wmde-markdown tt {\n  font-family: SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;\n}\n.wmde-markdown img {\n  max-width: 100%;\n}\n.wmde-markdown input {\n  vertical-align: middle;\n  margin: 0 0.2em 0.25em -1.6em;\n}\n.wmde-markdown input + p {\n  display: inline;\n}\n.wmde-markdown h1,\n.wmde-markdown h2 {\n  border-bottom: 1px solid #eaecef;\n  padding-bottom: 0.3em;\n}\n.wmde-markdown h1,\n.wmde-markdown h2,\n.wmde-markdown h3,\n.wmde-markdown h4,\n.wmde-markdown h5,\n.wmde-markdown h6 {\n  font-weight: 600;\n  line-height: 1.25;\n  margin-bottom: 16px;\n  margin-top: 24px;\n}\n.wmde-markdown h1 {\n  font-size: 2em;\n}\n.wmde-markdown h2 {\n  font-size: 1.5em;\n}\n.wmde-markdown h3 {\n  font-size: 1.25em;\n}\n.wmde-markdown h4 {\n  font-size: 1em;\n}\n.wmde-markdown h5 {\n  font-size: 0.875em;\n}\n.wmde-markdown h6 {\n  font-size: 0.85em;\n}\n.wmde-markdown ol,\n.wmde-markdown ul {\n  padding-left: 2em;\n}\n.wmde-markdown ol > p,\n.wmde-markdown ul > p {\n  margin-bottom: 0;\n}\n.wmde-markdown ul {\n  margin-bottom: 16px;\n  margin-top: 0;\n  list-style: initial;\n}\n.wmde-markdown > blockquote,\n.wmde-markdown > blockquote blockquote {\n  margin: 0;\n  border-left: 0.25em solid #dfe2e5;\n  color: #6a737d;\n  padding: 0 1em;\n}\n.wmde-markdown > blockquote > :last-child,\n.wmde-markdown > blockquote blockquote > :last-child {\n  margin-bottom: 0;\n}\n.wmde-markdown > blockquote > :first-child,\n.wmde-markdown > blockquote blockquote > :first-child {\n  margin-top: 0;\n}\n.wmde-markdown hr {\n  margin: 1.5em auto;\n  border: 0;\n  border-top: 2px dotted #eee;\n  height: 1px;\n}\n.wmde-markdown > table,\n.wmde-markdown > blockquote table {\n  display: block;\n  overflow: auto;\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n  font-size: 14px;\n}\n.wmde-markdown > table tr,\n.wmde-markdown > blockquote table tr {\n  background-color: #fff;\n  border-top: 1px solid #c6cbd1;\n}\n.wmde-markdown > table td,\n.wmde-markdown > blockquote table td,\n.wmde-markdown > table th,\n.wmde-markdown > blockquote table th {\n  border: 1px solid #dfe2e5;\n  padding: 6px 13px;\n}\n.wmde-markdown blockquote,\n.wmde-markdown details,\n.wmde-markdown dl,\n.wmde-markdown ol,\n.wmde-markdown p,\n.wmde-markdown pre,\n.wmde-markdown table,\n.wmde-markdown ul {\n  margin-bottom: 16px;\n  margin-top: 0;\n}\n.wmde-markdown a {\n  color: #0366d6;\n  text-decoration: none;\n}\n.wmde-markdown a:hover {\n  text-decoration: underline;\n}\n.wmde-markdown .namespace {\n  opacity: 0.7;\n}\n.wmde-markdown .token.important {\n  font-weight: normal;\n}\n.wmde-markdown .token.bold {\n  font-weight: bold;\n}\n.wmde-markdown .token.italic {\n  font-style: italic;\n}\n.wmde-markdown .token.entity {\n  cursor: help;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
